module.exports = __webpack_public_path__ + "media/images/referrals/card-over-mobile-caaaeb757cb6c7172fd6b98845e5d906.png";